module.exports = __webpack_public_path__ + "img/copper-diamond-line.5ab62c25.svg";